<template>
  <Modal title="新增" v-model="visible" width="900" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Form ref="form" :model="formData" class="page-form less" :label-width="80">
      <FormItem prop="code" label="渠道code" :rules="[$units.formRule.required('请输入'),{
          message: '渠道code只能是字母或数字',
          validator(rule, value) {
            const reg = /^[0-9a-zA-Z]*$/i
            return reg.test(value.trim());
          }
        }]">
        <Input type="text" v-model.trim="formData.code" :maxlength="32" :show-word-limit="true" placeholder="请输入" clearable></Input>
      </FormItem>
      <FormItem prop="fullName" label="渠道全称" :rules="$units.formRule.required('请输入')">
        <Input type="text" v-model.trim="formData.fullName" :maxlength="64" :show-word-limit="true" placeholder="请输入" clearable></Input>
      </FormItem>
      <FormItem prop="name" label="渠道简称" :rules="$units.formRule.required('请输入')">
        <Input type="text" v-model.trim="formData.name" :maxlength="64" :show-word-limit="true" placeholder="请输入" clearable></Input>
      </FormItem>
      <FormItem prop="channelType" label="公司性质" :rules="$units.formRule.required('请选择')">
        <RadioGroup v-model="formData.channelType">
          <Radio label="1">总公司</Radio>
          <Radio label="2">分公司</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="parentId" label="所属渠道" :rules="$units.formRule.required('请选择')" v-if="formData.channelType==2">
        <Select v-model="formData.parentId" placeholder="请选择" filterable>
          <Option v-for="(item,i) in userList" :value="item.id" :key="i">{{ item.name }}</Option>
        </Select>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false" ghost>取消</Button>
      <Button type="primary" @click="save" :loading="loading">确认</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      visible:false,
      loading:false,
      userList:[],
      formData:{
        code:"",
        fullName:"",
        name:"",
        channelType:"",
        parentId:"",
      },
    };
  },
  watch: {},
  computed: {
  },
  created() {},
  mounted() {
  },
  methods: {
    save(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        formData.resignTime = this.$units.formatDate(formData.resignTime);
        this.$http({
          url: "/buz/insuranceChannel/add",
          type: "post",
          data: formData
        }).then(res=>{
          this.visible = false;
          this.$notice.success("操作成功")
          this.$emit("success")
        })
        
      })
    },
    open(data){
      this.visible = true;
      this.$refs.form&&this.$refs.form.resetFields();
      this.getAll();
    },
    // 获取所有渠道
    getAll(){
      this.$http({
        url: '/buz/insuranceChannel/getAll',
        type: 'get',
        data: {},
      }).then((res) => {
        this.userList = res.data;
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  .info-text {
    font-size: 12px;
    color: #A8ADB7;
    line-height: 1.5;
    padding-top: 7px;
  }
  .password-icon {
    position: absolute;
    transform: translateX(-30px);
  }
  img.password-icon {
    width: 16px;
    top: 8px;
  }
  .ivu-icon-ios-eye {
    font-size: 18px;
    color: #A8ADB7;
    top: 7px;
  }
}
</style>